import React, { useState, useEffect, useLayoutEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
  Card,
  Row,
  Col,
  Button,
  Table,
  Form,
  InputGroup
} from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ActionButton from 'components/common/ActionButton';
import standardInfo from 'components/pages/haccp/standardInfo/ingredients/column/standardInfo';
import ingredientInfo from 'components/pages/haccp/standardInfo/ingredients/column/ingredientInfo';
// types
import { ACTION_TYPE } from 'types/type';
import { RESPONSE_CODE } from 'types/const';
// global
import { useConfirmModalState } from 'global/confirmModalState';
// function
import { getLoginInform } from 'function/login';
import { datas2SfshExcelJSON } from 'function/convert';
import { utils, writeFile } from 'xlsx';

// api
import {
  factory,
  category,
  category1,
  category2,
  category3,
  commonCode
} from 'api/haccp/commonApi';
import {
  registIrdntCreate,
  registIrdntDetail,
  registIrdntUpdate
} from 'api/haccp/standardInfo/ingredientsApi';
import { requestCodeCheck } from 'api/haccp/standardInfo/processInfoApi';
/**
 *  @description 등록성분량관리 상세
 */
const Detail = () => {
  /* router info*/
  const history = useHistory();
  const { state } = useLocation();
  const { seq } = useParams();

  /* recoil */
  const { setConfirmModal } = useConfirmModalState();

  /* state */
  const [adminYn, setAdminYn] = useState(null); // 'Y': 관리자, N: 이천,군산 담당자
  const [action, setAction] = useState('');
  const [actionType, setActionType] = useState('');
  const [validated, setValidated] = useState(false);
  const [factoryOptions, setFactoryOptions] = useState(null); // 공장
  const [unitOptions, setUnitOptions] = useState(null); // 단위
  const [categoryOptions, setCategoryOptions] = useState(null); // 분류(제품,공정,원료)
  const [category1Options, setCategory1Options] = useState(null); // 대분류
  const [category2Options, setCategory2Options] = useState(null); // 중분류
  const [category3Options, setCategory3Options] = useState(null); // 소분류

  // 분류 선택에 따른 대분류, 중분류, 소분류 Title변경
  const [category1Title, setCategory1Title] = useState(null);
  const [category2Title, setCategory2Title] = useState(null);
  const [category3Title, setCategory3Title] = useState(null);

  // 등록성분량 기본정보
  const [rgstrIngrd, setRgstrIngrd] = useState({
    ctgryGrpCd: null, // 분류
    pltCd: null, // 공장
    useYn: 'Y', // 사용유무
    ctgry1Cd: null, // 대분류
    ctgry2Cd: null, // 중분류
    ctgry3Cd: null, // 소분류
    isDisabled: false
  });

  // 등록성분 정보 목록
  const [rgstrIngrdList, setRgstrIngrdList] = useState([
    {
      itemNm: null, // 항목
      irdntVal: null, // 성분등록치
      unitCd: null, // 단위
      description: null, // 비고
      isDisabled: false
    }
  ]);

  /* event */

  /* 목록페이지 이동 */
  const onList = () => {
    history.push({
      pathname: '/haccp/ingredient',
      state: state
    });
  };

  /* 공장선택 */
  const onFactory = e => {
    const { value } = e.target || {};

    // 공장변경 시 하위(분류, 대,중,소분류) 초기화
    setRgstrIngrd({
      ...rgstrIngrd,
      pltCd: value,
      ctgryGrpCd: null,
      ctgry1Cd: null,
      ctgry2Cd: null,
      ctgry3Cd: null
    });

    setCategory1Options([]);
    setCategory2Options([]);
    setCategory3Options([]);
  };

  /**
   *  분류선택
   *  제품,원료 : 대분류, 중분류, 소분류 3Deps
   *  공정: 대분류, 중분류 2Deps
   */
  const onCategory = async e => {
    const { value } = e.target || {};

    // 분류 선택에 따른 대,중,소분류 타이틀 변경
    categoryTitleOfChange(value);

    // 대,중,소분류 초기화
    setRgstrIngrd({
      ...rgstrIngrd,
      ctgryGrpCd: value,
      ctgry1Cd: null,
      ctgry2Cd: null,
      ctgry3Cd: null
    });

    // 공정 대분류 API호출
    if (value === 'proc') {
      onProcess(value);
      return;
    }

    // 제품,원료 대분류 API호출
    const params = {
      ctgryGrpCd: value
    };

    const response = await category1(params);

    const { code, list } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    setCategory1Options(list);
    setCategory2Options([]);
    setCategory3Options([]);
  };

  /**
   * 분류 > 공정선택(대분류) API호출
   */
  const onProcess = async value => {
    const factorySeq = factoryOptions?.find(
      e => e.pltCd === rgstrIngrd.pltCd
    )?.seq;

    const params = {
      ctgryGrpCd: value,
      pltCd: rgstrIngrd.pltCd,
      pltCdSeq: factorySeq
    };

    const response = await category1(params);

    const { code, list } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    setCategory1Options(list);
    setCategory2Options([]);
    setCategory3Options([]);
    return;
  };

  /**
   * 대분류 선택  > 중분류 API호출
   */
  const onCategory1 = async e => {
    const { value } = e.target || {};

    setRgstrIngrd({
      ...rgstrIngrd,
      ctgry1Cd: value,
      ctgry2Cd: null,
      ctgry3Cd: null
    });

    const factorySeq = factoryOptions?.find(
      e => e.pltCd === rgstrIngrd.pltCd
    )?.seq;

    // 중분류 API호출
    const params = {
      ctgryGrpCd: rgstrIngrd.ctgryGrpCd,
      ctgry1Cd: value,
      pltCd: rgstrIngrd.pltCd,
      pltCdSeq: factorySeq
    };

    const response = await category2(params);

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setCategory2Options(list);
  };

  /**
   * 중분류 선택시  > 소분류 API호출
   */
  const onCategory2 = async e => {
    const { value } = e.target || {};

    setRgstrIngrd({
      ...rgstrIngrd,
      ctgry2Cd: value,
      ctgry3Cd: null
    });

    // 공정인 경우 2Deps 소분류 API호출 x
    if (rgstrIngrd.ctgryGrpCd === 'proc') return;

    // 제품,원료인 경우 3Deps 소분류 API호출
    const factorySeq = factoryOptions?.find(
      e => e.pltCd === rgstrIngrd.pltCd
    )?.seq;

    const params = {
      ctgryGrpCd: rgstrIngrd.ctgryGrpCd,
      ctgry2Cd: value,
      pltCd: rgstrIngrd.pltCd,
      pltCdSeq: factorySeq
    };

    // 소분류 API호출
    const response = await category3(params);

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;
    setCategory3Options(list);
  };

  /* 등록성분 정보목록 데이터 update */
  const updateFieldChanged = (e, index) => {
    const { name, value } = e.target || {};
    const newList = [...rgstrIngrdList];

    // 등록성분정보 > 항목 input Data 변경 시 중복검사 초기화
    if (name === 'itemNm') {
      newList[index] = {
        ...newList[index],
        [name]: value,
        isItemNmCheck: null
      };
      setRgstrIngrdList(newList);
      return;
    }

    newList[index] = { ...newList[index], [name]: value };
    setRgstrIngrdList(newList);
  };

  /* 등록성분정보 추가 */
  const infoListAdd = () => {
    const info = {
      itemNm: null, // 항목
      irdntVal: null, // 성분등록치
      unitCd: null, // 단위
      description: null, // 비고
      isDisabled: false,
      isItemNmCheck: null // 항목 중복체크
    };

    const newList = [...rgstrIngrdList, info];
    setRgstrIngrdList(newList);
  };

  /* 등록성분정보 삭제 */
  const infoListDelete = index => {
    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: '등록성분정보를 삭제하시겠습니까?',
      isConfirmBtn: true,
      isCancelBtn: true,
      onConfirm: () => {
        const newList = [...rgstrIngrdList];
        newList.splice(index, 1);
        setRgstrIngrdList(newList);
      }
    });
  };

  /* 등록성분 정보 항목 중복확인 */
  const duplicateCheck = async (index, itemNm) => {
    const requestBody = {
      procsInspReqCd: itemNm
    };

    const response = await requestCodeCheck(requestBody);

    const { code, data } = response || {};

    if (code !== RESPONSE_CODE.Success) return;

    const { duplicateYn } = data || {};

    let newList = [...rgstrIngrdList];

    if (duplicateYn === 'Y') {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '이미 등록된 항목 입니다.',
        isConfirmBtn: true
      });

      newList[index] = { ...newList[index], isItemNmCheck: false };
      setRgstrIngrdList(newList);
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: '사용가능한 항목 입니다.',
      isConfirmBtn: true
    });
    newList[index] = { ...newList[index], isItemNmCheck: true };
    setRgstrIngrdList(newList);
  };

  /* 등록 및 수정 */
  const handleSubmit = event => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    if (rgstrIngrdList.length === 0) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: '등록성분정보를 등록해주세요.',
        isConfirmBtn: true
      });
      return;
    }

    // 등록성분정보 중복체크1 - 중복확인 API요청
    // const isDuplicateCheck = rgstrIngrdList?.some(
    //   e => e.isItemNmCheck === null || e.isItemNmCheck === false
    // );

    // if (isDuplicateCheck === true) {
    //   setConfirmModal({
    //     isOpen: true,
    //     title: '확인',
    //     message: '항목 중복확인을 해주세요.',
    //     isConfirmBtn: true
    //   });
    //   return;
    // }

    // 등록성분정보 중복체크2 - 중복확인 API요청 후 동일 데이터 입력했을 경우
    // const setCollection = new Set(rgstrIngrdList?.map(JSON.stringify));
    // const isDuplicate = setCollection.size < rgstrIngrdList.length;

    // if (isDuplicate === true) {
    //   setConfirmModal({
    //     isOpen: true,
    //     title: '확인',
    //     message: '등록성분 정보에 동일한 항목이 있습니다.',
    //     isConfirmBtn: true
    //   });
    //   return;
    // }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: `등록성분량 관리를 ${action}하시겠습니까?`,
      isCancelBtn: true,
      isConfirmBtn: true,
      onConfirm: () => {
        onSubmit();
      }
    });
  };

  const onSubmit = async () => {
    const { pltCd, ctgryGrpCd, useYn, ctgry1Cd, ctgry2Cd, ctgry3Cd } =
      rgstrIngrd || {};
    let requestBody = {};
    let response = {};

    if (actionType === 'create') {
      // 등록
      requestBody = {
        pltCd: pltCd,
        ctgryGrpCd: ctgryGrpCd,
        ctgry1Cd: ctgry1Cd,
        ctgry2Cd: ctgry2Cd,
        ctgry3Cd: ctgry3Cd,
        useYn: useYn,
        registIrdntItemList: rgstrIngrdList
      };

      response = await registIrdntCreate(requestBody);
    } else {
      // 수정
      requestBody = {
        pltCd: pltCd,
        ctgryGrpCd: ctgryGrpCd,
        ctgry1Cd: ctgry1Cd,
        ctgry2Cd: ctgry2Cd,
        ctgry3Cd: ctgry3Cd,
        useYn: useYn,
        registIrdntItemList: rgstrIngrdList?.map(e => ({
          seq: e.seq !== undefined ? e.seq : undefined,
          registIrdntMstSeq:
            e.registIrdntMstSeq !== undefined ? e.registIrdntMstSeq : undefined,
          itemNm: e.itemNm,
          irdntVal: e.irdntVal,
          unitCd: e.unitCd,
          description: e.description
        }))
      };

      response = await registIrdntUpdate(seq, requestBody);
    }

    const { code, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    setConfirmModal({
      isOpen: true,
      title: '확인',
      message: `등록성분량 정보가 ${action} 되었습니다.`,
      isConfirmBtn: true
    });

    // 목록페이지 이동
    onList();
  };

  /* 엑셀다운로드 */
  const onExcelDown = () => {
    // gap rows
    function create_gap_rows(ws, nrows) {
      let ref = utils.decode_range(ws['!ref']); // get original range
      ref.e.r += nrows; // add to ending row
      ws['!ref'] = utils.encode_range(ref); // reassign row
    }

    let array = [];
    array.push(rgstrIngrd);

    const headers = ['등록성분량 기본정보', '등록성분 정보'];

    let obj = standardInfo;
    obj = {
      ...obj,
      ctgry1Nm: category1Title || '',
      ctgry2Nm: category2Title || '',
      ctgry3Nm: category3Title || ''
    };

    const firstExcelData = datas2SfshExcelJSON(array, obj);

    /* first data */
    // const ws = utils.aoa_to_sheet([[headers[0]]]);
    const worksheet = utils.sheet_add_json(worksheet, firstExcelData, {
      origin: -1
    });
    create_gap_rows(worksheet, 1); // one row gap after first table

    /* second data*/
    const secondExcelData = datas2SfshExcelJSON(rgstrIngrdList, ingredientInfo);
    // utils.sheet_add_aoa(ws, [[headers[1]]], { origin: -1 });
    utils.sheet_add_json(worksheet, secondExcelData, { origin: -1 });
    create_gap_rows(worksheet, 2);

    const wb = utils.book_new();
    utils.book_append_sheet(wb, worksheet);
    writeFile(wb, '등록성분 정보.xlsx');
  };

  /* 등록성분량 상세 API */
  const onDetail = async () => {
    const response = await registIrdntDetail(seq);

    const { code, data, message } = response || {};

    if (code !== RESPONSE_CODE.Success) {
      setConfirmModal({
        isOpen: true,
        title: '확인',
        message: message,
        isConfirmBtn: true
      });
      return;
    }

    const {
      pltCd,
      pltNm,
      ctgryGrpCd,
      ctgryGrpNm,
      useYn,
      ctgry1Cd,
      ctgry1Nm,
      ctgry2Cd,
      ctgry2Nm,
      ctgry3Cd,
      ctgry3Nm,
      registIrdntItemList
    } = data || {};

    // 분류 선택에 따른 대,중,소분류 타이틀 변경
    categoryTitleOfChange(ctgryGrpCd);

    // 등록성분량 기본정보 및 카테고리
    setRgstrIngrd({
      ...rgstrIngrd,
      pltCd: pltCd, // 공장
      pltNm: pltNm,
      ctgryGrpCd: ctgryGrpCd, // 분류
      ctgryGrpNm: ctgryGrpNm,
      useYn: useYn,
      ctgry1Cd: ctgry1Cd,
      ctgry1Nm: ctgry1Nm,
      ctgry2Cd: ctgry2Cd,
      ctgry2Nm: ctgry2Nm,
      ctgry3Cd: ctgry3Cd,
      ctgry3Nm: ctgry3Nm,
      isDisabled: true
    });

    // 등록성분 정보 목록
    setRgstrIngrdList(
      registIrdntItemList?.map(e => ({
        ...e,
        isItemNmCheck: true,
        isDisabled: true
      }))
    );
  };

  /* 분류 선택에 따른 대,중,소분류 타이틀 변경 */
  const categoryTitleOfChange = ctgryGrpCd => {
    switch (ctgryGrpCd) {
      case 'prdt':
        // 제품
        setCategory1Title('축종');
        setCategory2Title('등록명칭');
        setCategory3Title('등록명칭번호');
        break;
      case 'proc':
        // 공정
        setCategory1Title('공정명');
        setCategory2Title('의뢰명');
        setCategory3Title('');
        break;
      case 'rwmtr':
        // 원료
        setCategory1Title('자재번호');
        setCategory2Title('외부자재번호');
        setCategory3Title('원료명');
        break;
    }
  };

  /* 단위 API */
  const unitList = async () => {
    const params = {
      codeGroup: 'sfsh_unit',
      useYn: 'Y',
      sort: 'orders,asc'
    };
    const response = await commonCode(params);

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;
    setUnitOptions(list);
  };

  /* 분류목록 API */
  const categoryList = async () => {
    const response = await category();

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;
    setCategoryOptions(list);
  };

  /* 공장목록 API */
  const factoryList = async () => {
    const response = await factory();

    const { code, list } = response || {};
    if (code !== RESPONSE_CODE.Success) return;

    setFactoryOptions(list);
  };

  /* 로그인 정보 */
  const loginInfo = () => {
    const { adminYn, pltCd } = getLoginInform();

    if (adminYn === 'Y') {
      setAdminYn(adminYn);
      return;
    }

    setRgstrIngrd(prevState => ({
      ...prevState,
      pltCd: pltCd
    }));

    setAdminYn(adminYn);
  };

  /* watch */
  useEffect(() => {
    // 공장 API 호출
    factoryList();
    // 분류 API 호출
    categoryList();
    // 단위 API 호출
    unitList();
    // 로그인 정보
    loginInfo();
  }, []);

  useEffect(() => {
    switch (actionType) {
      case ACTION_TYPE.CREATE: {
        setAction('등록');
        break;
      }
      case ACTION_TYPE.UPDATE: {
        setAction('수정');
        onDetail();
        break;
      }
    }
  }, [actionType]);

  useLayoutEffect(() => {
    if (seq) {
      setActionType('update');
      return;
    }

    setActionType('create');
  }, []);

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="g-3 mb-3">
          <Col lg={6}>
            <Card className="h-100">
              <Card.Header>
                <Row className="align-items-center g-2">
                  <Col>
                    <h5 className="mb-0">등록성분량 기본 정보</h5>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="bg-light">
                {/* 공장 선택 select-box */}
                <Form.Group className="mb-3">
                  <Form.Label>*공장</Form.Label>
                  <Form.Select
                    required
                    size="sm"
                    onChange={e => onFactory(e)}
                    value={rgstrIngrd.pltCd || ''}
                    disabled={adminYn === 'N' || rgstrIngrd.isDisabled === true}
                  >
                    <option hidden value="">
                      공장선택
                    </option>
                    {factoryOptions?.map(option => (
                      <option key={option.pltCd} value={option.pltCd}>
                        {option.pltNmKo}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
                {/* 분류 선택 select-box */}
                <Form.Group className="mb-3">
                  <Form.Label>*분류</Form.Label>
                  <Form.Select
                    required
                    size="sm"
                    onChange={e => onCategory(e)}
                    value={rgstrIngrd.ctgryGrpCd || ''}
                    disabled={rgstrIngrd.isDisabled === true}
                  >
                    <option hidden value="">
                      분류선택
                    </option>
                    {categoryOptions?.map(option => (
                      <option key={option.ctgryCd} value={option.ctgryCd}>
                        {option.ctgryNmKr}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>*사용유무</Form.Label>
                  <Flex>
                    <Form.Check
                      type="radio"
                      id="use"
                      label="사용"
                      name="useYn"
                      value="Y"
                      checked={rgstrIngrd.useYn === 'Y'}
                      onChange={e =>
                        setRgstrIngrd({
                          ...rgstrIngrd,
                          useYn: e.target.value
                        })
                      }
                    />
                    <Form.Check
                      type="radio"
                      id="unuse"
                      label="미사용"
                      className="ms-3"
                      name="useYn"
                      value="N"
                      checked={rgstrIngrd.useYn === 'N'}
                      onChange={e =>
                        setRgstrIngrd({
                          ...rgstrIngrd,
                          useYn: e.target.value
                        })
                      }
                    />
                  </Flex>
                </Form.Group>
              </Card.Body>
            </Card>
          </Col>
          {/* 카테고리 설정 */}
          <Col lg={6}>
            <Card className="h-100">
              <Card.Header>
                <Row className="align-items-center g-2">
                  <Col>
                    <h5 className="mb-0">카테고리 설정</h5>
                  </Col>
                </Row>
              </Card.Header>
              {(rgstrIngrd.ctgryGrpCd === null ||
                rgstrIngrd.pltCd === null) && (
                <div className="h-100 d-flex align-items-center justify-content-center">
                  공장 및 분류를 선택해주세요.
                </div>
              )}
              {rgstrIngrd.ctgryGrpCd !== null && rgstrIngrd.pltCd !== null && (
                <Card.Body className="bg-light">
                  {/* 대분류 */}
                  <Form.Group className="mb-3">
                    <Form.Label>*{category1Title}</Form.Label>
                    {rgstrIngrd.isDisabled === false && (
                      <Form.Select
                        required
                        size="sm"
                        onChange={e => onCategory1(e)}
                        value={rgstrIngrd.ctgry1Cd || ''}
                      >
                        <option hidden value="">
                          {category1Title}선택
                        </option>
                        {category1Options?.map((option, index) => (
                          <option key={index} value={option.ctgry1Cd}>
                            {option.ctgry1Nm}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                    {rgstrIngrd.isDisabled === true && (
                      <Form.Control
                        type="text"
                        size="sm"
                        value={rgstrIngrd.ctgry1Nm || ''}
                        disabled={rgstrIngrd.isDisabled}
                      />
                    )}
                  </Form.Group>
                  {/* 중분류 */}
                  <Form.Group className="mb-3">
                    <Form.Label>*{category2Title}</Form.Label>
                    {rgstrIngrd.isDisabled === false && (
                      <Form.Select
                        required
                        size="sm"
                        onChange={e => onCategory2(e)}
                        value={rgstrIngrd.ctgry2Cd || ''}
                      >
                        <option hidden value="">
                          {category2Title}선택
                        </option>
                        {category2Options?.map(option => (
                          <option key={option.ctgry2Cd} value={option.ctgry2Cd}>
                            {option.ctgry2Nm}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                    {rgstrIngrd.isDisabled === true && (
                      <Form.Control
                        type="text"
                        size="sm"
                        value={rgstrIngrd.ctgry2Nm || ''}
                        disabled={rgstrIngrd.isDisabled}
                      />
                    )}
                  </Form.Group>
                  {/* 소분류 */}
                  {rgstrIngrd.ctgryGrpCd !== 'proc' && (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label>*{category3Title}</Form.Label>
                        {rgstrIngrd.isDisabled === false && (
                          <Form.Select
                            required
                            size="sm"
                            onChange={e =>
                              setRgstrIngrd({
                                ...rgstrIngrd,
                                ctgry3Cd: e.target.value
                              })
                            }
                            value={rgstrIngrd.ctgry3Cd || ''}
                          >
                            <option hidden value="">
                              {category3Title}선택
                            </option>
                            {category3Options?.map(option => (
                              <option
                                key={option.ctgry3Cd}
                                value={option.ctgry3Cd}
                              >
                                {option.ctgry3Nm}
                              </option>
                            ))}
                          </Form.Select>
                        )}
                        {rgstrIngrd.isDisabled === true && (
                          <Form.Control
                            type="text"
                            size="sm"
                            value={rgstrIngrd.ctgry3Nm || ''}
                            disabled={rgstrIngrd.isDisabled}
                          />
                        )}
                      </Form.Group>
                    </>
                  )}
                </Card.Body>
              )}
            </Card>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card>
              <Card.Header>
                <Row className="align-items-center g-2">
                  <Col>
                    <h5 className="mb-0">등록성분 정보</h5>
                  </Col>
                  {actionType === 'update' && (
                    <Col xs={'auto'}>
                      <Button
                        size="sm"
                        variant="secondary"
                        onClick={onExcelDown}
                        disabled={rgstrIngrdList?.length === 0}
                      >
                        엑셀 다운로드
                      </Button>
                    </Col>
                  )}
                </Row>
              </Card.Header>
              <Card.Body className="pt-0">
                <Table responsive bordered className="fs--1 text-center mb-0">
                  <thead className="bg-200 text-700 align-middle border-300">
                    <tr>
                      <th>*항목</th>
                      <th>*성분등록치</th>
                      <th>*단위</th>
                      <th>비고</th>
                      <th>
                        <Button size="sm" onClick={() => infoListAdd()}>
                          <FontAwesomeIcon
                            icon="plus"
                            className="text-white align-middle"
                          />
                        </Button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rgstrIngrdList?.map(
                      (
                        {
                          itemNm,
                          irdntVal,
                          unitCd,
                          description,
                          isDisabled,
                          isItemNmCheck
                        },
                        index
                      ) => (
                        <tr key={index}>
                          <td style={{ width: '30%' }}>
                            <InputGroup>
                              <Form.Control
                                required
                                type="text"
                                size="sm"
                                placeholder="10자 이내로 입력해주세요."
                                maxLength="10"
                                name="itemNm"
                                value={itemNm || ''}
                                onChange={e => updateFieldChanged(e, index)}
                                disabled={isDisabled}
                              />
                              {/* {isDisabled === false && (
                                <Button
                                  variant="success"
                                  size="sm"
                                  name="itemNm"
                                  disabled={itemNm === ''}
                                  onClick={() => duplicateCheck(index, itemNm)}
                                >
                                  중복확인
                                </Button>
                              )}
                              {isDisabled === false &&
                                isItemNmCheck === true && (
                                  <div className="text-primary d-flex align-items-center ms-2 fw-bold">
                                    사용가능
                                  </div>
                                )}
                              {isDisabled === false &&
                                isItemNmCheck === false && (
                                  <div className="text-danger d-flex align-items-center ms-2 fw-bold">
                                    중복코드
                                  </div>
                                )} */}
                            </InputGroup>
                          </td>
                          <td style={{ width: '20%' }}>
                            <Form.Control
                              required
                              type="text"
                              size="sm"
                              placeholder="10자 이내로 입력해주세요."
                              maxLength="10"
                              name="irdntVal"
                              value={irdntVal || ''}
                              onChange={e => updateFieldChanged(e, index)}
                            />
                          </td>
                          <td style={{ width: '15%' }}>
                            <Form.Select
                              required
                              size="sm"
                              className="w-100"
                              name="unitCd"
                              onChange={e => updateFieldChanged(e, index)}
                              value={unitCd || ''}
                            >
                              <option hidden value="">
                                단위선택
                              </option>
                              {unitOptions?.map(option => (
                                <option
                                  key={option.codeCd}
                                  value={option.codeCd}
                                >
                                  {option.codeNmKr}
                                </option>
                              ))}
                            </Form.Select>
                          </td>
                          <td style={{ width: '40%' }}>
                            <Form.Control
                              placeholder="20자 이내로 입력해주세요."
                              type="text"
                              size="sm"
                              maxLength="20"
                              name="description"
                              value={description || ''}
                              onChange={e => updateFieldChanged(e, index)}
                            />
                          </td>
                          <td style={{ width: '5%' }}>
                            {isDisabled === false && (
                              <ActionButton
                                icon="trash-alt"
                                title="삭제"
                                variant="action"
                                className="p-0 lh-1 text-danger"
                                onClick={() => infoListDelete(index)}
                              />
                            )}
                          </td>
                        </tr>
                      )
                    )}
                    {rgstrIngrdList.length < 1 && (
                      <tr>
                        <td colSpan={5} className="w-auto">
                          등록성분 정보를 등록해주세요.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Card.Body>
              <Card.Footer className="d-flex align-items-center">
                <Button
                  size="sm"
                  variant="secondary"
                  className="ms-auto"
                  onClick={() => onList()}
                >
                  취소
                </Button>
                <Button size="sm" className="ms-2" type="submit">
                  {action}
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default Detail;
